module.exports = __webpack_public_path__ + "static/media/brighteningcomplexplus.fabe0e6d.png";